import React from 'react';
import { Text, Link, Flex, Image } from '@chakra-ui/react';
import { SchemaSpec } from './types';

interface HeaderProps {
  schemas?: SchemaSpec[];
}

const link_color = "rgb(27, 121, 186)";

// The v3.0 schema page isn't published yet, so its URL 404s — render v3.0 as
// plain text (no link). Other versions (e.g. v2.8) link to their schema page.
const isLinkable = (s: SchemaSpec) => s.version !== "3.0";

const schemaLabel = (s: SchemaSpec, text: string) =>
  isLinkable(s) ? (
    <Link href={s.id} target="_blank" color={link_color}>{text}</Link>
  ) : (
    <Text as="span">{text}</Text>
  );

const renderSchemaList = (schemas: SchemaSpec[]) => {
  if (schemas.length === 0) return null;
  if (schemas.length === 1) {
    const s = schemas[0];
    return schemaLabel(s, `OMC-JSON Schema v${s.version}`);
  }
  const items = schemas.map((s, i) => (
    <React.Fragment key={s.id}>
      {schemaLabel(s, `v${s.version}`)}
      {i < schemas.length - 2 ? ", " : i === schemas.length - 2 ? " and " : ""}
    </React.Fragment>
  ));
  return <>OMC-JSON Schemas {items}</>;
};

const Synopsis: React.FC<HeaderProps> = ({ schemas = [] }) => (
  <Flex>
      <Text fontSize="md" padding="20px 0px 0 0">
        This is a validator for the <Link color={link_color} target="_blank" href="https://movielabs.com/production-technology/ontology-for-media-creation/">MovieLabs Ontology for Media Creation</Link> that checks compliance to the {renderSchemaList(schemas)} and best practices. Refer to the <Link color={link_color} target="_blank" href="/api/static/manual.pdf">manual</Link> for more information.
      </Text>
      <Image src="/api/static/2030_vision_logo_black_r_white_text.png" alt="MovieLabs Logo" mt="2px" style={{ height: '80px', }} />
  </Flex>
);

export default Synopsis;
